// UK Computing Curriculum Aligned Network Lessons

export const lessons = [
  // Lesson 1
  {
    id: 'lesson-physical-layer-troubleshooting',
    title: 'Physical Layer Troubleshooting',
    difficulty: 'Beginner',
    duration: '15 minutes',
    curriculum: 'KS3 Computing - Networks',
    description: 'Learn to identify and fix physical connection issues in a school network environment.',
    scenario: 'Mike has complained he can access his network files on his laptop fine but cannot see them on his PC. He also states Internet is not working on his PC either. Investigate the network setup and try to find the connection issues with Mike\'s PC.',
    ocrTopics: ['1.3.1.c'],
    objectives: [
      'Understand the Physical layer',
      'Identify connection issues',
    ],
    topology: {
      devices: [
        {
          name: 'Mike\'s Laptop',
          type: 'laptop',
          x: 198,
          y: 135,
          powered: true,
          ip: '192.168.1.106',
          subnet: '255.255.255.0',
          gateway: '',
          networkTag: 'School Network',
        },
        {
          name: 'Mike\'s PC',
          type: 'pc',
          x: 753,
          y: 142,
          powered: true,
          ip: '192.168.1.81',
          subnet: '255.255.255.0',
          gateway: '',
          networkTag: 'School Network',
        },
        {
          name: 'School Switch 1',
          type: 'switch',
          x: 509,
          y: 369,
          powered: true,
          ip: '192.168.1.156',
          subnet: '255.255.255.0',
          gateway: '',
          networkTag: 'School Network',
        },
        {
          name: 'File Server',
          type: 'server',
          x: 142,
          y: 570,
          powered: true,
          ip: '192.168.1.159',
          subnet: '255.255.255.0',
          gateway: '',
          networkTag: 'School Network',
        },
      ],
      connections: [
        { from: 'Mike\'s Laptop', to: 'School Switch 1', fromPort: 0, toPort: 0 },
        { from: 'File Server', to: 'School Switch 1', fromPort: 0, toPort: 1 },
      ],
    },
    challenges: [
      {
        id: 1,
        title: 'Test connection from Mike\'s Laptop to the File Server',
        description: 'Use the Ping Command to verify the connection',
        hint: '',
        solution: 'ping 192.168.1.159',
      },
      {
        id: 2,
        title: 'Test connection from Mike\'s PC to the File Server',
        description: 'Ping the File server to see if the connection is active.',
        hint: '',
        solution: '',
      },
      {
        id: 3,
        title: 'Search for connection issues',
        description: 'Check Mike\'s PC for any connections. Is it connected to the switch?',
        hint: 'Create a new connection',
        solution: '',
      },
    ],
  },
  
  
  
  {
    id: 'lesson-1-basic-connection',
    title: 'Lesson 1: Basic Network Connection',
    difficulty: 'Beginner',
    duration: '15 minutes',
    curriculum: 'KS3 Computing - Networks',
    description: 'Learn how two computers connect and communicate on a simple network.',
    objectives: [
      'Understand direct device connections',
      'Configure IP addresses on devices',
      'Use ping to test connectivity',
      'Understand the importance of the same subnet',
    ],
    topology: {
      devices: [
        {
          name: 'PC-1',
          type: 'pc',
          x: 300,
          y: 250,
          powered: true,
          ip: '192.168.1.10',
          subnet: '255.255.255.0',
        },
        {
          name: 'PC-2',
          type: 'pc',
          x: 600,
          y: 250,
          powered: true,
          ip: '192.168.1.20',
          subnet: '255.255.255.0',
        },
      ],
      connections: [
        {
          from: 'PC-1',
          to: 'PC-2',
          fromPort: 0,
          toPort: 0,
        },
      ],
    },
    challenges: [
      {
        id: 1,
        title: 'Test Basic Connectivity',
        description: 'Use the ping command from PC-1 to test connection to PC-2',
        hint: 'Select PC-1, open terminal, and type: ping 192.168.1.20',
        solution: 'ping 192.168.1.20',
      },
      {
        id: 2,
        title: 'View IP Configuration',
        description: 'Check the IP configuration on PC-1',
        hint: 'Type: ipconfig',
        solution: 'ipconfig',
      },
      {
        id: 3,
        title: 'Test Power States',
        description: 'Power off PC-2 and try to ping it again. What happens?',
        hint: 'Click PC-2, power it off, then ping 192.168.1.20 from PC-1',
      },
    ],
  },

  {
    id: 'lesson-2-switch',
    title: 'Lesson 2: Network Switch',
    difficulty: 'Beginner',
    duration: '20 minutes',
    curriculum: 'KS3 Computing - Network Topology',
    description: 'Learn how a switch connects multiple devices on a network.',
    objectives: [
      'Understand star topology',
      'Learn how switches forward data',
      'Test connectivity through a switch',
      'Understand MAC addresses and ARP',
    ],
    topology: {
      devices: [
        {
          name: 'PC-1',
          type: 'pc',
          x: 200,
          y: 150,
          powered: true,
          ip: '192.168.1.10',
          subnet: '255.255.255.0',
        },
        {
          name: 'PC-2',
          type: 'pc',
          x: 500,
          y: 150,
          powered: true,
          ip: '192.168.1.20',
          subnet: '255.255.255.0',
        },
        {
          name: 'PC-3',
          type: 'pc',
          x: 350,
          y: 400,
          powered: true,
          ip: '192.168.1.30',
          subnet: '255.255.255.0',
        },
        {
          name: 'Switch-1',
          type: 'switch',
          x: 350,
          y: 250,
          powered: true,
          ip: '192.168.1.5',
          subnet: '255.255.255.0',
        },
      ],
      connections: [
        { from: 'PC-1', to: 'Switch-1', fromPort: 0, toPort: 0 },
        { from: 'PC-2', to: 'Switch-1', fromPort: 0, toPort: 1 },
        { from: 'PC-3', to: 'Switch-1', fromPort: 0, toPort: 2 },
      ],
    },
    challenges: [
      {
        id: 1,
        title: 'Test Switch Connectivity',
        description: 'Ping from PC-1 to PC-2 through the switch',
        hint: 'Select PC-1, type: ping 192.168.1.20',
        solution: 'ping 192.168.1.20',
      },
      {
        id: 2,
        title: 'View ARP Table',
        description: 'Check the ARP table on PC-1 to see MAC address mappings',
        hint: 'Type: arp -a',
        solution: 'arp -a',
      },
      {
        id: 3,
        title: 'Test Switch Failure',
        description: 'Start continuous ping, then power off the switch. What happens?',
        hint: 'Type: ping -t 192.168.1.20, then power off Switch-1',
        solution: 'ping -t 192.168.1.20',
      },
    ],
  },

  {
    id: 'lesson-3-router',
    title: 'Lesson 3: Routers and Gateways',
    difficulty: 'Intermediate',
    duration: '25 minutes',
    curriculum: 'KS4 Computing - Internet and Routing',
    description: 'Learn how routers connect different networks together.',
    objectives: [
      'Understand different network subnets',
      'Configure default gateways',
      'Learn how routers forward packets',
      'Use traceroute to see packet paths',
    ],
    topology: {
      devices: [
        {
          name: 'PC-A',
          type: 'pc',
          x: 200,
          y: 200,
          powered: true,
          ip: '192.168.1.10',
          subnet: '255.255.255.0',
          gateway: '192.168.1.1',
        },
        {
          name: 'Router-1',
          type: 'router',
          x: 400,
          y: 250,
          powered: true,
          ip: '192.168.1.1',
          subnet: '255.255.255.0',
        },
        {
          name: 'PC-B',
          type: 'pc',
          x: 600,
          y: 200,
          powered: true,
          ip: '192.168.2.20',
          subnet: '255.255.255.0',
          gateway: '192.168.2.1',
        },
      ],
      connections: [
        { from: 'PC-A', to: 'Router-1', fromPort: 0, toPort: 0 },
        { from: 'Router-1', to: 'PC-B', fromPort: 1, toPort: 0 },
      ],
    },
    challenges: [
      {
        id: 1,
        title: 'Understand Different Networks',
        description: 'Check the IP configuration on both PCs. Notice they\'re on different subnets!',
        hint: 'Use ipconfig on both PC-A and PC-B',
        solution: 'ipconfig',
      },
      {
        id: 2,
        title: 'Test Inter-Network Communication',
        description: 'Ping from PC-A to PC-B across the router',
        hint: 'On PC-A, type: ping 192.168.2.20',
        solution: 'ping 192.168.2.20',
      },
      {
        id: 3,
        title: 'Trace the Route',
        description: 'Use traceroute to see the path packets take',
        hint: 'On PC-A, type: traceroute 192.168.2.20',
        solution: 'traceroute 192.168.2.20',
      },
    ],
  },

  {
    id: 'lesson-4-complex-network',
    title: 'Lesson 4: Complex Network Design',
    difficulty: 'Advanced',
    duration: '30 minutes',
    curriculum: 'KS4 Computing - Network Design',
    description: 'Design and troubleshoot a complete network with multiple devices.',
    objectives: [
      'Understand complex network topologies',
      'Configure multiple devices correctly',
      'Troubleshoot connectivity issues',
      'Understand network reliability',
    ],
    topology: {
      devices: [
        {
          name: 'PC-1',
          type: 'pc',
          x: 150,
          y: 150,
          powered: true,
          ip: '192.168.1.10',
          subnet: '255.255.255.0',
          gateway: '192.168.1.1',
        },
        {
          name: 'PC-2',
          type: 'pc',
          x: 300,
          y: 150,
          powered: true,
          ip: '192.168.1.20',
          subnet: '255.255.255.0',
          gateway: '192.168.1.1',
        },
        {
          name: 'Switch-1',
          type: 'switch',
          x: 225,
          y: 280,
          powered: true,
          ip: '192.168.1.5',
          subnet: '255.255.255.0',
        },
        {
          name: 'Router-1',
          type: 'router',
          x: 400,
          y: 280,
          powered: true,
          ip: '192.168.1.1',
          subnet: '255.255.255.0',
        },
        {
          name: 'Server-1',
          type: 'server',
          x: 550,
          y: 150,
          powered: true,
          ip: '192.168.2.100',
          subnet: '255.255.255.0',
          gateway: '192.168.2.1',
        },
        {
          name: 'PC-3',
          type: 'pc',
          x: 700,
          y: 150,
          powered: true,
          ip: '192.168.2.30',
          subnet: '255.255.255.0',
          gateway: '192.168.2.1',
        },
      ],
      connections: [
        { from: 'PC-1', to: 'Switch-1', fromPort: 0, toPort: 0 },
        { from: 'PC-2', to: 'Switch-1', fromPort: 0, toPort: 1 },
        { from: 'Switch-1', to: 'Router-1', fromPort: 2, toPort: 0 },
        { from: 'Router-1', to: 'Server-1', fromPort: 1, toPort: 0 },
        { from: 'Server-1', to: 'PC-3', fromPort: 1, toPort: 0 },
      ],
    },
    challenges: [
      {
        id: 1,
        title: 'Test Local Network',
        description: 'Verify PC-1 can communicate with PC-2',
        hint: 'From PC-1, type: ping 192.168.1.20',
        solution: 'ping 192.168.1.20',
      },
      {
        id: 2,
        title: 'Test Server Access',
        description: 'Can PC-1 reach the server on the other network?',
        hint: 'From PC-1, type: ping 192.168.2.100',
        solution: 'ping 192.168.2.100',
      },
      {
        id: 3,
        title: 'Troubleshoot Failure',
        description: 'Use continuous ping to monitor stability, then power off Switch-1',
        hint: 'Type: ping -t 192.168.2.100, then turn off Switch-1',
        solution: 'ping -t 192.168.2.100',
      },
    ],
  },

{
  id: 'lesson-router-interfaces',
  title: 'Lesson 5: Router Interfaces & Network Segmentation',
  difficulty: 'Advanced',
  duration: '35 minutes',
  curriculum: 'KS4 Computing - Advanced Routing',
  description: 'Learn how routers use different interfaces to connect multiple networks, and understand network segmentation.',
  
  objectives: [
    'Understand router interfaces and their purpose',
    'Configure multiple IP addresses on a router',
    'Recognize network segmentation with tags',
    'Route traffic between three different networks',
  ],
  
  topology: {
    devices: [
      // Office Network (192.168.1.x)
      {
        name: 'PC-Office-1',
        type: 'pc',
        x: 150,
        y: 150,
        powered: true,
        ip: '192.168.1.10',
        subnet: '255.255.255.0',
        gateway: '192.168.1.1',
        networkTag: 'Office Network',
      },
      {
        name: 'PC-Office-2',
        type: 'pc',
        x: 300,
        y: 150,
        powered: true,
        ip: '192.168.1.20',
        subnet: '255.255.255.0',
        gateway: '192.168.1.1',
        networkTag: 'Office Network',
      },
      
      // Central Router with 3 interfaces
      {
        name: 'Router-Main',
        type: 'router',
        x: 400,
        y: 300,
        powered: true,
        networkTag: 'Core Infrastructure',
        interfaces: [
          {
            port: 0,
            ip: '192.168.1.1',
            subnet: '255.255.255.0',
          },
          {
            port: 1,
            ip: '10.0.0.1',
            subnet: '255.255.255.0',
          },
          {
            port: 2,
            ip: '172.16.0.1',
            subnet: '255.255.255.0',
          },
        ],
      },
      
      // Admin Network (10.0.0.x)
      {
        name: 'Server-Admin',
        type: 'server',
        x: 550,
        y: 150,
        powered: true,
        ip: '10.0.0.100',
        subnet: '255.255.255.0',
        gateway: '10.0.0.1',
        networkTag: 'Admin Network',
      },
      {
        name: 'PC-Admin',
        type: 'pc',
        x: 700,
        y: 150,
        powered: true,
        ip: '10.0.0.50',
        subnet: '255.255.255.0',
        gateway: '10.0.0.1',
        networkTag: 'Admin Network',
      },
      
      // Guest Network (172.16.0.x)
      {
        name: 'Laptop-Guest-1',
        type: 'laptop',
        x: 550,
        y: 450,
        powered: true,
        ip: '172.16.0.10',
        subnet: '255.255.255.0',
        gateway: '172.16.0.1',
        networkTag: 'Guest Network',
      },
      {
        name: 'Laptop-Guest-2',
        type: 'laptop',
        x: 700,
        y: 450,
        powered: true,
        ip: '172.16.0.20',
        subnet: '255.255.255.0',
        gateway: '172.16.0.1',
        networkTag: 'Guest Network',
      },
    ],
    
    connections: [
      // Office Network to Router Port 0
      { from: 'PC-Office-1', to: 'Router-Main', fromPort: 0, toPort: 0 },
      { from: 'PC-Office-2', to: 'Router-Main', fromPort: 0, toPort: 0 },
      
      // Admin Network to Router Port 1
      { from: 'Server-Admin', to: 'Router-Main', fromPort: 0, toPort: 1 },
      { from: 'PC-Admin', to: 'Router-Main', fromPort: 0, toPort: 1 },
      
      // Guest Network to Router Port 2
      { from: 'Laptop-Guest-1', to: 'Router-Main', fromPort: 0, toPort: 2 },
      { from: 'Laptop-Guest-2', to: 'Router-Main', fromPort: 0, toPort: 2 },
    ],
  },
  
  challenges: [
    {
      id: 1,
      title: 'Identify Network Segmentation',
      description: 'Look at the colored network tags. How many separate networks are there?',
      hint: 'Count the different colored badges: Office (blue), Admin (purple), Guest (orange), plus Core Infrastructure',
    },
    {
      id: 2,
      title: 'View Router Interfaces',
      description: 'Select Router-Main and open its configuration. Examine the three interfaces.',
      hint: 'Click Router-Main, then click the config (gear) button. Scroll to "Router Interfaces"',
    },
    {
      id: 3,
      title: 'Test Office to Office Communication',
      description: 'Ping from PC-Office-1 to PC-Office-2. They\'re on the same network.',
      hint: 'Select PC-Office-1, open terminal: ping 192.168.1.20',
      solution: 'ping 192.168.1.20',
    },
    {
      id: 4,
      title: 'Test Cross-Network Routing',
      description: 'Ping from PC-Office-1 to Server-Admin. Notice they use different gateways!',
      hint: 'From PC-Office-1: ping 10.0.0.100',
      solution: 'ping 10.0.0.100',
    },
    {
      id: 5,
      title: 'Trace the Multi-Hop Path',
      description: 'Use traceroute from PC-Office-1 to Laptop-Guest-1. See all three networks!',
      hint: 'From PC-Office-1: traceroute 172.16.0.10',
      solution: 'traceroute 172.16.0.10',
    },
    {
      id: 6,
      title: 'Test Router Failure Impact',
      description: 'Use continuous ping from Office to Admin network, then power off the router.',
      hint: 'From PC-Office-1: ping -t 10.0.0.100, then power off Router-Main',
      solution: 'ping -t 10.0.0.100',
    },
    {
      id: 7,
      title: 'Understand Interface Addressing',
      description: 'Each router interface has its own IP address. Why is this necessary?',
      hint: 'Each interface connects to a different network (192.168.1.x, 10.0.0.x, 172.16.0.x). The router needs an IP in each network to route between them.',
    },
  ],
}

]
;

// Get lessons by difficulty
export function getLessonsByDifficulty(difficulty) {
  return lessons.filter(lesson => lesson.difficulty === difficulty);
}

// Get lesson by ID
export function getLessonById(id) {
  return lessons.find(lesson => lesson.id === id);
}

export default lessons;


